import { ParentProps, createContext, onMount, useContext } from 'solid-js'
import { requireContext, focus } from 'common'
import { focus as api } from 'st-app/api'
import { FocusContext } from './FocusContext'

const FocusContextJsx = focus.FocusContextJsx;
export const useFocusContext = () => focus.useFocusContext() as FocusContext;
export const requireFocusContext = () => focus.requireFocusContext() as FocusContext;

export class FocusProps { }

export default function Focus(props: ParentProps<FocusProps>) {
    const context = new FocusContext();

    return (
        <FocusContextJsx.Provider value={context}>
            {props.children}
        </FocusContextJsx.Provider>
    )
}

Focus.defaultProps = new FocusProps();

const focusKeys: Record<string, string> = {};
export function fetchFocusKey(orgGU: string, yearGU: string) {
    const key = `${orgGU}_${yearGU}`;

    return new Promise<string>((resolve, reject) => {
        if (focusKeys[key]) {
            resolve(focusKeys[key]);
            return;
        }


    });
}